export default function Resize() {
	window.addEventListener('resize', (e) => handleResize(e), {passive: true});

	const handleResize = (e) => {
		// console.log('resized', e);
	};
}
